import { Component, Input } from '@angular/core';

@Component({
    selector: 'rwidget-alert',
    templateUrl: './alert.component.html'
})
export class AlertComponent {
    /** Optional target id. If provided, it's forwarded to child alert widgets so they show only targeted alerts. */
    @Input() target?: string;
    /** Optional assets path for child alert components. */
    @Input() assetsPath = 'assets';
}
